import React from 'react';
import {useNavigate} from 'react-router-dom'
import AOS from "aos"
import { useTheme } from '../components/ThemeContext';
const Register = () => {
  const { isDarkMode } = useTheme();
  AOS.init({
    duration: 1200,
  });
  const navigate = useNavigate();
  return (
    <div className={`bg-gray-900 ${isDarkMode ? 'dark' : ''}`}>

    <div data-aos="flip-right" className="dark:bg-gray-800 bg-gray-500 min-h-screen flex flex-col justify-center items-center">
      <div className="max-w-md w-full bg-white dark:bg-gray-700 shadow-lg rounded-lg overflow-hidden">
        <div className="px-6 py-8">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">Entry Test Preparation</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">Welcome! Get started with your test preparation by filling out the form below:</p>
          <a href="https://forms.gle/tNLn9Zb3sJ4jpQKY7" target="_blank" rel="noopener noreferrer" className="bg-[#3FE0A5] hover:bg-[#235191] hover:text-white font-bold py-2 px-4 rounded-lg inline-block">Fill Google Form</a>
          <button className='flex mt-6 bg-gray-500 p-2 px-5 rounded-lg text-white hover:bg-gray-400 hover:text-black' onClick={() => {navigate(-1)}}>Back</button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Register;
